import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import clsx from 'clsx'
import {Invoice} from '../core/_models'
import {
  API_URL,
  KTIcon,
  fixZero,
  isNotEmpty,
  numberWithCommas,
} from '../../../../../../_metronic/helpers'
import {CustomInputs} from '../../../../../../_metronic/helpers/components/CustomInputs'
import axios from 'axios'
import {GoldPriceCal} from '../invoice-edit-modal/item/GoldPriceCal'

type Props = {
  invoice: Invoice
  setShowBuyModal: Dispatch<SetStateAction<boolean>>
}

const BuyGoldModal: FC<Props> = ({invoice, setShowBuyModal}) => {
  const [carat, setCarat] = useState('740')
  const [qty, setQty] = useState('')
  const [fee, setFee] = useState('')
  const [priceCalShow, setPriceCalShow] = useState(false)

  const getSum: () => number = () => {
    return fixZero((parseFloat(fee) || 0) * (parseFloat(qty) || 1))
  }

  const save = () => {
    setShowBuyModal(false)
    axios
      .post(`${API_URL}/payment/add`, {
        hash: invoice.hsh,
        price: getSum(),
        type: 2,
        description: `خرید طلا به وزن ${qty} گرم`,
      })
      .then(() => {
        window.location.reload()
      })
  }

  useEffect(() => {
    if (isNotEmpty(carat)) {
      setCarat(fixZero(parseFloat(carat)).toString())
    }
  }, [carat])

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_product'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-xl modal-fullscreen-sm-down'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>خرید طلا</h2>
              {/* end::Modal title */}

              {/* begin::Close */}
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-products-modal-action='close'
                onClick={() => {
                  setShowBuyModal(false)
                }}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
              {/* end::Close */}
            </div>
            {/* begin::Modal body */}
            <div className='modal-body scroll-y'>
              <div className='border border-1 border-primary border-dashed rounded my-5 bg-light-primary p-3 text-center fs-3x text-primary'>
                <div className='fs-5 text-gray-500'>باقیمانده:</div>
                {numberWithCommas(invoice.pymr)} <span className='fs-5 text-gray-500'>ریال</span>
              </div>
              <div className='separator separator-dashed border-gray-500 mb-10'></div>
              <div className='row'>
                <div className='col-12'>
                  <CustomInputs
                    type={'number'}
                    label={'وزن'}
                    stateValue={{value: qty, setValue: setQty}}
                  />
                </div>
                <div className='col-12'>
                  <CustomInputs
                    type={'number'}
                    max={3}
                    label={'عیار'}
                    stateValue={{value: carat, setValue: setCarat}}
                  />
                </div>
                <div className='col-12'>
                  <CustomInputs
                    type={'currency'}
                    label={'مبلغ'}
                    stateValue={{value: fee, setValue: setFee}}
                  >
                    <div className='input-group-prepend'>
                      <span
                        className='form-control form-control-solid py-lg-2 p-1 px-5 bg-primary fw-bolder'
                        style={{
                          borderRightWidth: '0px',
                          borderTopRightRadius: '0px',
                          borderBottomRightRadius: '0px',
                        }}
                        onClick={() => {
                          setPriceCalShow(true)
                        }}
                      >
                        <i className='las la-calculator text-white' style={{fontSize: '35px'}}></i>
                      </span>
                    </div>
                  </CustomInputs>
                </div>
              </div>
              <div className='border border-1 border-success border-dashed rounded my-5 bg-light-success p-3 text-center fs-3x text-success'>
                {numberWithCommas(getSum())} <span className='fs-5 text-gray-500'>ریال</span>
              </div>
              <button className='btn btn-success w-100 mt-5' onClick={save}>
                ذخیره
              </button>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {priceCalShow && (
        <GoldPriceCal
          fee={{fee: fee, setFee: setFee}}
          carat={{carat: carat, setCarat: setCarat}}
          popupHandle={{show: priceCalShow, hide: setPriceCalShow}}
        />
      )}
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {BuyGoldModal}
